let headerContactBtn = document.querySelector(".header__contact-btn");
let headerContactModalBox = document.querySelector(".header__contact-modal-box");
let headerContactModal = document.querySelector(".header__contact-modal");
let headerContactCloseModal = document.querySelector(
  ".header__contact-modal-close-svg-box"
);
let leadingSwithBox = document.querySelector(".leasing-slider__switch-box");
let privateSlider = document.querySelector(".private-slider");
let businessSlider = document.querySelector(".business-slider");
let burger = document.querySelector(".header__buger");
let headerNavList = document.querySelector(".header__nav");
let closeListBtn = document.querySelector(".mobile-list-close");

let requestLeasingModalBox = document.querySelector(".lid-form");
let requestLeasingModal = document.querySelector(".lid-form-box");
let requestLeasingOpenBtn = document.querySelectorAll(".request-leasing");
let closeRequestModalBtn = document.querySelector(".lid-form-svg-box");

let cookieBox = document.querySelector(".cookie-box");
let cookieapproved = document.querySelector(".coockie-approve")
let cookiereject = document.querySelector(".coockie-reject")

function noScrollBody() {
  document.body.classList.add("noscroll");
}

function removeNoScrollBody() {
  document.body.classList.remove("noscroll");
}


// *** HEADER COTNACT MODAL ***
headerContactBtn?.addEventListener("click", () => {
  headerContactModal.classList.add("modal-open");
  headerContactModalBox.classList.remove("dnone");
  noScrollBody()

});

headerContactCloseModal?.addEventListener("click", () => {
  headerContactModal.classList.remove("modal-open");
  headerContactModalBox.classList.add("dnone");
  removeNoScrollBody()
});

headerContactModalBox?.addEventListener("click", (event) => {
  if (!(event.target.closest(".header__contact-modal"))) {
    headerContactModal.classList.remove("modal-open");
    headerContactModalBox.classList.add("dnone");
    removeNoScrollBody()
  }
});

document?.addEventListener('keydown', (event) => {
  if (event.code === 'Escape') {
    headerContactModal.classList.remove("modal-open");
    headerContactModalBox.classList.add("dnone");
    graphBox.classList.add("dnone");
    requestLeasingModalBox.classList.add("dnone");

    let subList = document.querySelectorAll(".header__dropdown");
    headerNavList.style.display = "none";
    subList.forEach(item => item.classList.remove("openedSublist"))
    removeNoScrollBody()
  }
})
// *** END HEADER COTNACT MODAL***

// *** FORM REQUEST LEASING ***
requestLeasingOpenBtn.forEach(item => {
  item.addEventListener("click", () => {
    requestLeasingModalBox.classList.remove("dnone");
    noScrollBody()
  })
})

closeRequestModalBtn?.addEventListener("click", () => {
  requestLeasingModalBox.classList.add("dnone");
  removeNoScrollBody()
});

requestLeasingModalBox.addEventListener("click", (event) => {
  if (!(event.target.closest(".lid-form__box"))) {
    requestLeasingModalBox.classList.add("dnone");
    removeNoScrollBody()
  }
})

// *** END FORM REQUEST LEASING ***

// *** SWITH SLIDER ***

leadingSwithBox?.addEventListener("click", ({ target }) => {
  if (target.classList.contains("business-button")) {
    leadingSwithBox
      .querySelector(".private-button")
      .classList.remove("switch--active");
    target.classList.add("switch--active");

    privateSlider.classList.add("dnone");
    businessSlider.classList.remove("dnone");
  }

  if (target.classList.contains("private-button")) {
    leadingSwithBox
      .querySelector(".business-button")
      .classList.remove("switch--active");

    target.classList.add("switch--active");
    businessSlider.classList.add("dnone");
    privateSlider.classList.remove("dnone");
  }
});
// ***END SWITH SLIDER ***

// *** BOTTOM MENU ***
document.addEventListener('DOMContentLoaded', function() {
    const menuConfig = [
        { btnId: 'menuToggle-leasing', menuId: 'leasing-menu' },
        { btnId: 'menuToggle-still', menuId: 'still-menu' },
        { btnId: 'menuToggle-factoring', menuId: 'factoring-menu' }
    ];

    const menus = [];
    const currentPath = window.location.pathname;

    menuConfig.forEach(config => {
        const btn = document.getElementById(config.btnId);
        const template = document.getElementById(config.menuId);
        
        if (!btn || !template) return;

        const menu = template.content.firstElementChild.cloneNode(true);
        const parent = btn.closest('.button') || btn.closest('li');
        if (!parent) return;

        parent.appendChild(menu);
        
        let hasActive = false;
        menu.querySelectorAll('a').forEach(link => {
            const href = link.getAttribute('href');
            if (href && (currentPath === href || (href !== '/' && currentPath.startsWith(href)))) {
                hasActive = true;
            }
        });

        if (hasActive) {
            parent.classList.add('has-active-page');
        }

        menus.push({ btn, menu, parent, id: config.btnId });
    });

    const extraFactoringPaths = [
        '/dokumenty-factoring-yuridicheskie-lica',
        '/raskrytie-informacii-factoring',
        '/dokumenty-factoring-ip'
    ];
    
    const factoringMenu = menus.find(m => m.id === 'menuToggle-factoring');
    if (factoringMenu && extraFactoringPaths.some(p => currentPath === p || currentPath.startsWith(p + '/'))) {
        factoringMenu.parent.classList.add('has-active-page');
    }

    const bottomButtons = document.querySelectorAll('.buttons .button, .buttons .button-pro');
    bottomButtons.forEach(btn => {
        const link = btn.querySelector('a');
        if (!link) return;
        
        const href = link.getAttribute('href');
        if (!href) return;
        
        if (href === '/catalog' && (
            currentPath === '/catalog' || 
            currentPath.startsWith('/catalog/') ||
            currentPath === '/moto-catalog' || 
            currentPath.startsWith('/moto-catalog/') ||
            currentPath === '/seized-equipment-catalog' || 
            currentPath.startsWith('/seized-equipment-catalog/')
        )) {
            btn.classList.add('has-active-page');
        }
        
        if (href === '/' && currentPath === '/') {
            btn.classList.add('has-active-page');
        }
    });

    menus.forEach(item => {
        item.btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            menus.forEach(m => {
                if (m !== item) {
                    m.menu.classList.remove('active');
                    m.parent.classList.remove('active');
                }
            });
            
            const isActive = !item.menu.classList.contains('active');
            item.menu.classList.toggle('active');
            item.parent.classList.toggle('active', isActive);
        });
    });

    document.addEventListener('click', function(e) {
        menus.forEach(item => {
            if (!item.parent.contains(e.target)) {
                item.menu.classList.remove('active');
                item.parent.classList.remove('active');
            }
        });
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            menus.forEach(item => {
                item.menu.classList.remove('active');
                item.parent.classList.remove('active');
            });
        }
    });
});
// *** END BOTTOM MENU ***

// *** SWICTH NEWS ***


const showCards = (attribute) => {
  let cards = document.querySelectorAll('.news__card');
  cards.forEach(card => {
    const date = card.getAttribute('data-tag');
    if (date === attribute) {
      card.style.display = 'block';
    } else {
      card.style.display = 'none';
    }
    swiperNews.update()
  });
};


const btnSwitchAll = document.querySelector('.all-button');
const btnSwitchNews = document.querySelector('.news-button');
const btnSwitchBlog = document.querySelector('.blog-button');

btnSwitchNews?.addEventListener('click', () => {
  btnSwitchNews.classList.add("switch--active")
  btnSwitchAll.classList.remove("switch--active")
  btnSwitchBlog.classList.remove("switch--active")
  showCards('news');
});

btnSwitchBlog?.addEventListener('click', () => {
  btnSwitchBlog.classList.add("switch--active")
  btnSwitchNews.classList.remove("switch--active")
  btnSwitchAll.classList.remove("switch--active")
  showCards('blog');
});
btnSwitchAll?.addEventListener('click', () => {
  btnSwitchAll.classList.add("switch--active")
  btnSwitchNews.classList.remove("switch--active")
  btnSwitchBlog.classList.remove("switch--active")
  let cards = document.querySelectorAll('.news__card');
  cards.forEach(card => {
    card.style.display = 'block';
  })
  swiperNews.update()
})

// END SWITH NEWS

// *** OPEN LIST AND BURGER MENU ***
burger?.addEventListener('click', ({ target }) => {
  let modalArrows = Array.from(document.querySelectorAll(".header-item-mobile-arrow"));
  headerNavList.style.display = "block";
  noScrollBody()

  modalArrows.forEach((arrow) => {
    let openListItem = arrow.closest('.header__nav-dropdown-box')
    let closeBox = openListItem.querySelector('.mobile-list-heading')

    openListItem?.addEventListener('click', () => {
      openListItem.querySelector('.header__dropdown').classList.add('openedSublist')
    })


    closeBox?.addEventListener('click', (event) => {
      event.stopPropagation()
      openListItem?.querySelector('.header__dropdown').classList.remove('openedSublist')
    }
    );
  })
})

closeListBtn?.addEventListener('click', () => {
  let subList = document.querySelectorAll(".header__dropdown");
  headerNavList.style.display = "none";
  [...subList].reverse().forEach(item => item.classList.remove("openedSublist"))
  removeNoScrollBody()
});
// *** END OPEN LIST AND BURGER MENU ***




//*** FORM MODAL ***
function renderFormModal() {
  let formDoneRequestModal = document.querySelector(".form-contact-modal");
  let openFormModalBtn = document.querySelector(".get-consultation");
  let closeFormModalBtn = document.querySelector(".form-contact-modal__close-svg");
  let resendOnMainPage = document.querySelector(".form-contact-modal__cta")

  formDoneRequestModal.classList.remove("dnone")
  noScrollBody()

  closeFormModalBtn?.addEventListener("click", () => {
    formDoneRequestModal.classList.add("dnone")
    removeNoScrollBody()

  })

  resendOnMainPage.addEventListener("click", () => {
    formDoneRequestModal.classList.add("dnone")
    removeNoScrollBody()

  })

  window.addEventListener("click", ({ target }) => {
    if (target == formDoneRequestModal) {
      formDoneRequestModal.classList.add("dnone")
      removeNoScrollBody()

    }
  })
}
// ***END FORM MODAL***

//  *** ACCORDEON ***
const accordion = document?.querySelector(".accordion");

accordion?.addEventListener("click", (e) => {
  if (e.target.classList.contains("documents__link")) return;
  const activePanel = e.target.closest(".accordion-panel");
  if (!activePanel) return;
  toggleAccordion(activePanel);
});

function toggleAccordion(panelToActivate) {
  const activeButton = panelToActivate?.querySelector("button");
  const activePanel = panelToActivate?.querySelector(".accordion-content");
  const activePanelIsOpened = activeButton?.getAttribute("aria-expanded");

  if (activePanelIsOpened === "true") {
    panelToActivate
      .querySelector("button")
      .setAttribute("aria-expanded", false);

    panelToActivate
      .querySelector(".accordion-content")
      .setAttribute("aria-hidden", true);
  } else {
    panelToActivate.querySelector("button").setAttribute("aria-expanded", true);

    panelToActivate
      .querySelector(".accordion-content")
      .setAttribute("aria-hidden", false);
  }
}
//  *** END ACCORDEON ***

// // COOCKIE MODAL
// document.addEventListener("DOMContentLoaded", () => {
//   if (localStorage.coockie) {
//     return
//   }
//   cookieBox.classList.remove('dnone')

//   cookieapproved.addEventListener('click', () => {
//     localStorage.setItem('coockie', true);
//     cookieBox.classList.add('dnone')
//   })

//   cookiereject.addEventListener('click', () => {
//     localStorage.setItem('coockie', false);
//     cookieBox.classList.add('dnone')
//   })
// })

// // END COOKIE

// *** FORM VALIDATOR ***
// import {Inputmask} from './inputmask.min.js'
require('./inputmask.min.js')
let inputs = document.querySelectorAll('input[type="tel"]');
let im = new Inputmask('+375 (99) 999-99-99');
im.mask(inputs);

function validationForm(formIdName, formBtnClassName,) {
  let form = document.querySelector(`#${formIdName}`);
  if (!form) return false;

  let formBtn = document.querySelector(`.${formBtnClassName}`);
  let nameInput = form.querySelector(`input[name="name"]`);
  let phoneInput = form.querySelector('input[name="phone"]');
  let chekBox = form.querySelector('input[name="terms"]');

  function inputStyle(inputName) {
    let input = form.querySelector(`input[name="${inputName}"]`);
    let inputNameLow = input.closest('.lid-form__input-box').querySelector('.lid-form__input-name');
    input?.addEventListener('focusout', ({ target }) => {
      if (target === phoneInput && (phoneInput.value.includes('_') || phoneInput.value.length === 0)) {
        target.classList.add('invalid');
        target.classList.remove('valid');
        inputNameLow.classList.remove("formLowNameVisible");
      }
      else if (nameInput && input.value.length === 0) {
        target.classList.add('invalid');
        target.classList.remove('valid');
        inputNameLow.classList.remove("formLowNameVisible");
      }
      else {
        input.classList.remove('invalid');
        input.classList.add('valid');
        inputNameLow.classList.add("formLowNameVisible");
      }
    });
  }

  formBtn?.addEventListener('click', (event) => {
    if (!nameInput.value || !chekBox.checked || phoneInput.value.includes('_') || !phoneInput.value.length) {
      form.classList.add('invalid-form');

      if (phoneInput.value.includes('_') || !phoneInput.value.length) {
        phoneInput.classList.add('invalid');
      }

      if (nameInput.value.length === 0) {
        nameInput.classList.add('invalid');
      }

      if (!chekBox.checked) {
        chekBox.classList.add('invalid-chekbox');
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else {
      form.classList.remove('invalid-form');
    }
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    e.stopPropagation();
    let mailPath = "/contact-send";
    if(this.classList.contains('sendToAction')) {
      mailPath = this.action;
    }

    let th = this,
      params = new FormData(this),
      request = new XMLHttpRequest();
    const requestButton = this.querySelector('.cta')
    requestButton.disabled = true
    var origText = requestButton.innerText
    requestButton.innerText = 'Отправка...'

    request.open("POST", mailPath, true);
    request.send(params);

    request.onload = function() {
      requestButton.disabled = false
      requestButton.innerText = origText
    };
    request.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        setTimeout(function () {
          th.reset();
        }, 1000);

        renderFormModal();
        form.reset();

        nameInput.classList.remove('valid');
        phoneInput.classList.remove('valid');
        chekBox.classList.remove('invalid-chekbox');
        requestLeasingModalBox.classList.add("dnone");
      }
    };

    return false;
  });

  inputStyle('name');
  inputStyle("phone");
}

function validationPersonalDataForm(formIdName, formBtnClassName,) {
  let form = document.querySelector(`#${formIdName}`);
  if (!form) return false;

  let formBtn = document.querySelector(`.${formBtnClassName}`);
  let nameInput = form.querySelector(`input[name="name"]`);
  let phoneInput = form.querySelector('input[name="phone"]');
  let emailInput = form.querySelector('input[name="email"]');

  function inputStyle(inputName) {
    let input = form.querySelector(`input[name="${inputName}"]`);
    let inputNameLow = input.closest('.lid-form__input-box').querySelector('.lid-form__input-name');
    input?.addEventListener('focusout', ({ target }) => {
      if (target === phoneInput && (phoneInput.value.includes('_') || phoneInput.value.length === 0)) {
        target.classList.add('invalid');
        target.classList.remove('valid');
        inputNameLow.classList.remove("formLowNameVisible");
      }
      else if (target === nameInput && nameInput.value.length === 0) {
        target.classList.add('invalid')
        target.classList.remove('valid');
        inputNameLow.classList.remove("formLowNameVisible");
      }
      else if (target === emailInput && ((emailInput.value.length === 0) || !emailInput.value.includes('@'))) {
        target.classList.add('invalid');
        target.classList.remove('valid');
        inputNameLow.classList.remove("formLowNameVisible");
      }
      else {
        input.classList.remove('invalid');
        input.classList.add('valid');
        inputNameLow.classList.add("formLowNameVisible");
      }
    });
  }

  formBtn?.addEventListener('click', (event) => {
    if (!nameInput.value || !emailInput.value || phoneInput.value.includes('_') || !phoneInput.value.length) {
      form.classList.add('invalid-form');

      if (phoneInput.value.includes('_') || !phoneInput.value.length) {
        phoneInput.classList.add('invalid');
      }

      if (nameInput.value.length === 0) {
        nameInput.classList.add('invalid');
      }

      if (emailInput.value.length === 0) {
        emailInput.classList.add('invalid');
      }

      event.preventDefault();
      event.stopPropagation();
    }
    else {
      form.classList.remove('invalid-form');
    }
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const mailPath = "/contact-send";

    let th = this,
      params = new FormData(this),
      request = new XMLHttpRequest();

    request.open("POST", mailPath, true);
    request.send(params);

    request.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        setTimeout(function () {
          th.reset();
        }, 1000);

        renderFormModal();
        form.reset();

        nameInput.classList.remove('valid');
        phoneInput.classList.remove('valid');
        emailInput.classList.remove('valid');
        requestLeasingModalBox.classList.add("dnone");
      }
    };

    return false;
  });

  inputStyle('name');
  inputStyle("phone");
  inputStyle("email");
}

validationForm('lid-form', 'get-consultation');
validationForm('form-request', 'get-consultation-main');
validationPersonalDataForm('personal-data', 'get-consultation-main-personal');


// CATALOG BRANDS LOAD MOBILE

let brandsBox = document.querySelector(".brands-box")
let brandsArr = brandsBox?.querySelectorAll(".brands-item");
if (brandsArr) brandsArr = Array.from(brandsBox.querySelectorAll(".brands-item"));
let openMoreBrandsBtn = document.querySelector(".brands-cta");

if (window.innerWidth < 768) {
  brandsArr?.reduce((acc, item) => {
    if (acc >= 9) {
      item.classList.add("dnone")
    }
    return ++acc
  }, 0)
}

openMoreBrandsBtn?.addEventListener("click", function ({ target }) {
  brandsArr.forEach(item => item.classList.remove("dnone"));
  target.classList.add("dnone")
}
);

if (window.innerWidth < 768) {
  if (brandsArr) {
    brandsArr.reduce((acc, item) => {
      if (acc >= 9) {
        item.classList.add("dnone")
      }
      return ++acc
    }, 0)
  }
  else {
    if (brandsArr) {
      brandsArr.forEach(item => item.classList.remove("dnone"));
    }
  }
}


// format numbers
document.querySelectorAll('.hasFormatNumber')?.forEach(item => {
  item.addEventListener('change', updateFormatedNumber)
  item.addEventListener('change-custom', updateFormatedNumber)
  updateFormatedNumberTo(item)
})

function updateFormatedNumber(e, elem = null) {
  updateFormatedNumberTo(this)
}
function updateFormatedNumberTo(elem) {
  let formatedNumberSpan = elem.nextElementSibling
  formatedNumberSpan.innerHTML = formatNumber(elem.value)
}
function formatNumber(number) {

  return new Intl.NumberFormat("ru-RU").format(
      number,
  )
}
window.updateFormatedNumberTo = updateFormatedNumberTo

// additional form phone validation
let buttons = document.querySelectorAll('form button');
buttons?.forEach(button => button.addEventListener('click', additionalFormPhoneValidation))
function additionalFormPhoneValidation(e) {
  let form = this.closest('form');
  let phone = form.querySelector('input[name="phone"]');
  let errorMessage = form.querySelector('.lid-form__invalid-msg-text');
  const regex = /\((17|25|29|33|44)\)/;
  // const oldMessageValue = errorMessage.innerText
  if(phone.value != '' && !regex.test(phone.value)) {
    e.preventDefault();
    e.stopPropagation();
    // let inputNameLow = phone.closest('.lid-form__input-box').querySelector('.lid-form__input-name');
    phone.classList.add('invalid');
    phone.classList.remove('valid');
    form.classList.remove('invalid-form')
    form.classList.add('invalid-form')
    errorMessage.innerText = 'Проверьте код оператора. Доступные значения 17, 25, 29, 33 и 44.';
  } else {
    errorMessage.innerText = 'Заполните все поля и чекбокс';
  }
}

const switchViewButtons = document.querySelectorAll('.switchViewButton')
switchViewButtons?.forEach(item => item.addEventListener('click', switchViewButtonsHandle))
function switchViewButtonsHandle(e) {
  e.preventDefault();
  console.log(this)
  let selector = this.getAttribute('search')
  if(!selector) return;
  document.querySelectorAll('.'+selector)?.forEach(item => item.classList.remove('dnone'))
  this.classList.add('dnone')
}

const preventElems = document.querySelectorAll('.prevent')
preventElems?.forEach(item => item.addEventListener('click', (e) => {
  e.preventDefault();
}))


function saveIdToLocalStorage() {
  let urlParams = new URLSearchParams(window.location.search)
  if(!urlParams) {
    return
  }

  let gclid = urlParams.get('gclid')
  let wbraid = urlParams.get('wbraid')
  let yclid = urlParams.get('yclid')
  if(yclid) {
    localStorage.setItem('yclid', yclid)
  }
  if(gclid) {
    localStorage.setItem('gclid', gclid)
  }

  if(wbraid) {
    localStorage.setItem('wbraid', wbraid)
  }
}
function addFieldsToForms() {
  let forms = document.querySelectorAll('form')

  forms?.forEach(item => {
    let inputYclid = createHiddenInputFromLocalStorage('yclid', 'yclid')
    let inputGclid = createHiddenInputFromLocalStorage('gclid', 'gclid')
    let inputWbraid = createHiddenInputFromLocalStorage('wbraid', 'wbraid')

    if(inputYclid) {
      item.appendChild(inputYclid)
    }
    if(inputGclid) {
      item.appendChild(inputGclid)
    }
    if(inputWbraid) {
      item.appendChild(inputWbraid)
    }
  })
}
function createHiddenInputFromLocalStorage(name, localStorageName) {
  let value = localStorage.getItem(localStorageName)
  if(!value) {
    return false
  }
  let input = document.createElement('input')
  input.type = 'hidden'
  input.name = name
  input.value = value
  return input
}

saveIdToLocalStorage()
addFieldsToForms()